import React from "react";

import "./Label.css";

import Row from "../../uiElements/grid/Row";
import Col from "../../uiElements/grid/Col";
import PatientOnboardingIcon from "../../uiElements/icons/onboardingIcons/PatientOnboardingIcon";

const Lable = ({ onclick, value, name }) => (
  <Row className="label-row">
    <Col className="mt-2 mb-n1">
      <label className="label-container" name={name}>
        {value}
      </label>
    </Col>
    <Col className="mt-n5 mb-1">
      <div
        onClick={onclick}
        className="icon"
        style={{ marginTop: "2%", marginLeft: "95%" }}
      >
        <PatientOnboardingIcon type="removeButton" />
      </div>
    </Col>
  </Row>
);

export default Lable;
